module.exports = __webpack_public_path__ + "static/st-2-premium-hover-12cf48d055f13531ab4a410372e0d853.jpg";